<p-toast [baseZIndex]="1000" position="top-right"></p-toast>
<div class="container-fluid">
  <div class="card-panel mt-5">
    <div class="row">
      <div class="col-md-6">
        <lib-page-header page-title="Unidades Administrativas"
          page-subtitle="EXERCÍCIO:  {{login.exercicio.ano}} - {{login['ppa']['descricao']}}"
          image-title="assets/img/hierarchy.png">
        </lib-page-header>
      </div>
      <div class="col-md-6">
        <a (click)="voltar()" class="btn btn-sm btn-outline-secondary float-right ml-5">
          <img src="assets/img/global/cross.png" alt="sair" title="Sair" height="20" width="20">
        </a>
        <lib-export-list (acao)="exportarListagem($event)"></lib-export-list>
        <a *ngIf="orgaoSelect && podeIncluir()" [routerLink]="['/unidades/novo', orgaoSelect.id]"
          class="btn btn-sm btn-outline-success float-right">
          <img src="assets/img/global/plus.png" alt="novo" class="mr-2" title="Incluir" height="20" width="20">Novo
        </a>
      </div>
    </div>
    <hr class="mt-1" />
    <div class="row">
      <div class="col-md-7">
        <select #orgao (change)="alternarOrgao(orgao.value)" name="selectOrgao" id="selectOrgao"
          style="border: none !important" style="font-weight: bold; color: #1565c0" class="custom-select">
          <option [selected]="item.id === orgaoSelect.id" [value]="item.id" *ngFor="let item of listaOrgaos">
            {{item.codigo}} {{item.nome}}
          </option>
        </select>
      </div>
      <div class="offset-1 col-md-4">
        <lib-filtro [(filtro)]="filtro" (localizaClick)="onClick($event)" (localizaKeydown)="onClick($event)">
        </lib-filtro>
      </div>
    </div>
    <div class="row">
      <div class="col-md">
        <div class="table-responsive">
        <table class="table table-eddy">
          <thead>
            <tr>
              <th scope="col" class="text-center">Código</th>
              <th scope="col" class="text-center">Nº Tribunal</th>
              <th scope="col">Nome</th>
              <th scope="col" class="text-lef">Responsável</th>
              <th scope="col">Cargo</th>
              <th scope="col" style="width: 90px;"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of lista">
              <th scope="row" class="text-center">{{item.codigo}}</th>
              <td class="text-center">{{item.tribunal}}</td>
              <td>
                {{item.nome}}
              </td>
              <td class="text-lef">{{item.responsavel}}</td>
              <td>{{item.cargo}}</td>
              <td class="text-right" style="min-width: 100px;">
                <button [routerLink]="['/unidades', item.id, 'visualizar', orgaoSelect.id]"
                  routerLinkActive="router-link-active" *ngIf="!podeIncluir()"
                  class="btn btn-sm btn-outline-secondary mr-2">
                  <img src="assets/img/global/zoom.png" alt="visualizar" height="16" width="16">
                </button>
                <button [routerLink]="['/unidades', item.id, 'editar', orgaoSelect.id]"
                  routerLinkActive="router-link-active" *ngIf="podeIncluir()"
                  class="btn btn-sm btn-outline-primary mr-2">
                  <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      </div>
    </div>
    <div class="row float-right" *ngIf="lista && lista.length > 0">
      <div class="col-12 mb-5">
        <lib-paginacao [(paginaCorrente)]="paginaCorrente" [(paginaTotal)]="paginaTotal"
          (paginaAnterior)="paginaAnterior()" (proximaPagina)="proximaPagina()"></lib-paginacao>
      </div>
    </div>
    <br>
    <br>
  </div>
</div>
